module.exports = __webpack_public_path__ + "images/517f77f46da00ecc769f24eadbd588722d9e0d8f947c60baf0f2b77388fc5148.svg";